// extracted by mini-css-extract-plugin
module.exports =  {"ratePairRow":"fW9ZzbBQwT3wWf6KYpMQ","arrowIcon":"hbytx190LB9XokRW6oin","fixedInput":"Mk0D6loZ1bBsfUhylJEG"};